import { twMerge } from 'tailwind-merge';
import { Typography } from '@scale/scaleui';

type ViewTitleProps = {
  className?: string;
  children?: string;
};

const ViewTitle: React.FC<ViewTitleProps> = ({ className, children }: ViewTitleProps) => {
  const formatTitle = children?.replace(/-/g, ' ');

  return (
    <Typography.H4 className={twMerge('capitalize font-medium text-neutral-900', className)}>
      {formatTitle}
    </Typography.H4>
  );
};

export { ViewTitle };
